import React, { useEffect, useState, SyntheticEvent } from 'react';
import { observer } from 'mobx-react';
import Human from './human';
import Color from '@/tool/color';
import UniversalTable from './universal-table';
import Empty from '@/component/empty';
import moWelfare from '../store/wealfare';
import { isEmpty } from 'lodash';



interface IProps { }
interface IState { }

const KeyHoliday = (props: IProps, state: IState) => {
  const { KeyFestivalsDate, KeyFestivalsList } = moWelfare;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="average-budget-pic" id="keyholidy">
      <section className="average-salary-item-01">
        <section>
          <span className="sub-title">重点节日人均福利</span>
        </section>
      </section>
      {!isEmpty(KeyFestivalsList) ? (
        <section className="average-salary-item-02">
          <Human />
          <p
            style={{
              color: Color.blackColor(0.25),
              fontSize: '12px',
              marginBottom: '20px',
            }}>单位（人民币 CNY）
          </p>
          <UniversalTable
            labelList={KeyFestivalsList}
            legendList={['25分位', '50分位', '75分位']}
            rateList={KeyFestivalsDate}
            type="number" />
        </section>
      ) : <Empty />}
    </section>
  );
};

export default observer(KeyHoliday);
